(function () {
  function initCarousel(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var track = root.querySelector('[data-carousel-track]');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    if (!track || !prevBtn || !nextBtn) return;

    var desktopQuery = window.matchMedia('(min-width: 768px)');

    function getSlides() {
      return Array.prototype.slice.call(track.querySelectorAll('[data-carousel-slide]'));
    }

    function getStep() {
      var slides = getSlides();
      if (!slides.length) return 0;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      if (desktopQuery.matches) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
        return;
      }

      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 4;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 4;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    desktopQuery.addEventListener('change', updateButtons);
    window.addEventListener('resize', updateButtons);
    root._updateCarouselButtons = updateButtons;
    updateButtons();
  }

  function refreshAll() {
    document.querySelectorAll('[data-job-ready-carousel]').forEach(function (root) {
      if (typeof root._updateCarouselButtons === 'function') {
        root._updateCarouselButtons();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-job-ready-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('job-ready-tab-changed', function () {
    window.setTimeout(refreshAll, 50);
  });
})();
